/**
 * BWS BV Angular Service.
 *
 * NOTE: Invokes the loader.js script.
 */
class CurationService {
    constructor() {
        const categoryList = {
            beer: 122,
            wine: 49,
            spirits: 51,
            premix: 81
        };
        function getCategoryId(location) {
            const objCategory = {};
            switch (location) {
                case '/wine':
                    objCategory.categoryId = categoryList.wine;
                    objCategory.displayId = 'wine';
                    break;
                case '/beer':
                    objCategory.categoryId = categoryList.beer;
                    objCategory.displayId = 'beer';
                    break;
                case '/spirits':
                    objCategory.categoryId = categoryList.spirits;
                    objCategory.displayId = 'spirits';
                    break;
                case '/spirits/premixed-drinks':
                    objCategory.categoryId = categoryList.premix;
                    objCategory.displayId = 'premix';
                    break;
            }
            return objCategory;
        }
        //3- Remove the script if injected previously
        function isScriptInjected(url) {
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; ++i) {
                if (scripts[i] && scripts[i].getAttribute('src') !== null && scripts[i].getAttribute('src').indexOf(url) !== -1) {
                    scripts[i].parentNode.removeChild(scripts[i]);
                    break;
                }
            }
        }
        //2- Load the script loader.js
        function loadsScriptBV() {
            const urls = 'https://static.curations.bazaarvoice.com/gallery/bws/prod/loader.js';
            //Clear the script if already injected
            isScriptInjected(urls);
            const customEleScript = document.createElement('script');
            customEleScript.setAttribute('src', urls);
            customEleScript.setAttribute('type', 'text/javascript');
            customEleScript.async = document.location.pathname === '/';
            document.getElementsByTagName('head')[0].appendChild(customEleScript);
            return new Promise((res) => {
                customEleScript.onload = res;
            });
        }
        //4- Reset the curation data
        function resetBazaarVoiceCurations(location) {
            if (document.getElementById('bv-carousel') !== null) {
                // Homepage
                if (location === '/') {
                    window.BVWidgets.display(
                        {
                            display: 'homepage',
                            categoryId: ['']
                        }, function () { } // Optional callback function.
                    );
                } else {
                    // category pages
                    const category = getCategoryId(location);
                    window.BVWidgets.display(
                        {
                            display: category.displayId,
                            categoryId: category.categoryId
                        }, function () { } // Optional callback function.
                    );
                }
                //Reset the object
                if (window.BVWidgets) {
                    if (window.BVWidgets.reset) {
                        window.BVWidgets.reset();
                    }
                    window.BVWidgets.isLoaded = false;
                    window.BVWidgets._displayConfig = undefined;
                }
            }
        }
        //1- Start the curation
        CurationService.prototype.showCuration = function (location) {
            //Load bazaar voice script on route change
            loadsScriptBV().then((res) => {
                if (res) {
                    setTimeout(function () {
                        resetBazaarVoiceCurations(location);
                    }, 600);
                }
            });
        };
    }
}

module.exports = CurationService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/bazaarvoicecuration/bazaarvoicecuration-service.js
 **/